import React from "react"

import { Flex } from "components/Flex"

import Summary from "components/Summary/Summary"
import i18n from "intl/i18n"
import { InvoiceAssignmentStatus } from "models/Invoice"
import { ISummarySection } from "@/types"
import { IListItem } from "components/List/List"
import { getInvoiceAssignmentStatusLabel, getInvoiceAssignmentStatusLightType } from "utils/utils"
import StatusLight from "components/StatusLight/StatusLight"

export interface IInvoiceSidebarSummaryProps {
    summary: ISummarySection<IListItem>[]
}

const RenderInvoiceAssignmentStatus = ({ status }: { status: InvoiceAssignmentStatus }) => {
    return (
        <Flex justifyContent="center">
            <div className="mr-1">
                {getInvoiceAssignmentStatusLabel(status)}
            </div>
            <StatusLight type={getInvoiceAssignmentStatusLightType(status)} />
        </Flex>
    )
}

const InvoiceSidebarSummary = ({ summary }: IInvoiceSidebarSummaryProps) => {
    return (
        <Summary data={summary.map(summaryItem => {
            return {
                ...summaryItem,
                items: summaryItem.items.map(item => {
                    return {
                        label: item.label,
                        value: item.label === i18n.t('invoices.assignmentStatus') ?
                            (
                                <RenderInvoiceAssignmentStatus status={item.value as InvoiceAssignmentStatus} />
                            ) :
                            item.value,
                        subLabel: item.subLabel,
                        subValue: item.subValue
                    }
                })
            }
        })} />
    )
}

export default InvoiceSidebarSummary
